import { Box, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import RevisorService from "../../services/RevisorService";
import { AprobacionData, GetVoidAprobacionData } from "../../types/Revisor/AporbacionData";
import { GestorCard } from "../../componente/Revisor/GestorCard";
import { CardReview } from "../../componente/Revisor/CardAnuncioReview";
import { TbSend, TbSendOff } from "react-icons/tb";
import { BsClockHistory } from "react-icons/bs";
import { SeguimientoForm } from "../../componente/Revisor/SeguimientoForm";
import SweetAlertUtil from "../../utils/SweetAlert";
import { GenericResponse } from "../../types/Response/GenericResponse";
import { SeguimientoCreationDTO } from "../../types/Seguimiento/SeguimientoCreationDTO";
import SegumientoService from "../../services/SeguimientoService";
import { themePalette } from "../../config/theme.config";

export const AprobarPage: React.FC<{}> = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(true);
    const [aprobAnun, setAprobAnun] = useState<AprobacionData>(GetVoidAprobacionData());
    const [open, setOpen] = useState(false);
    const [sending, setSending] = useState(false);
    // funciones
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const GetAnuncio = (id: number) => {
        setLoading(true);
        RevisorService.GetAnunciosParaAprobar(id).then((resp) => {
            setAprobAnun(resp);
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            setLoading(false);
        })
    }
    const handleResponse = async (responseData: GenericResponse) => {
        handleClose();
        setSending(true)
        if (responseData.status === 201) {
            SweetAlertUtil.alertaExito('Exito', 'Observación enviada');
            setTimeout(() => {
                navigate('/reviewer');
            }, 3000);
        } else {
            SweetAlertUtil.alertaAdvertencia('Alerta', responseData.message)
        }
        setTimeout(() => {
            setSending(false)
        }, 2000);
    };
    //Si se aprueba no se necesita el formulario
    const Aprobar = (idanuncio: number) => {
        setSending(true)
        const obj: SeguimientoCreationDTO = {
            idAnuncio: idanuncio,
            txObservacion: '',
            bdIsReiterativo: 0,
            bdEstado: 'A',
        }
        SegumientoService.UpdateStatus(obj)
            .then((resp) => {
                if (resp.status === 201) {
                    SweetAlertUtil.alertaExito('Exito', 'Comunicado aprobado');
                    setTimeout(() => {
                        navigate('/reviewer/aprobacion');
                    }, 3000);
                } else {
                    SweetAlertUtil.alertaAdvertencia('Alerta', resp.message)
                }
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                setSending(false);
            })
    }
    // Effect
    useEffect(() => {
        GetAnuncio(parseInt(id ?? '', 10));
    }, []);
    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', alignContent: 'center', alignItems: 'center', marginTop: 10, border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    APROBAR
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', m: 2 }}>
                <Grid container spacing={2}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <CardReview anuncio={aprobAnun?.anuncio} />
                    )}
                </Grid>
            </Box>
            <br />
            <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <GestorCard gestor={aprobAnun?.gestor} />
                    )}
                </Grid>
                <Grid item sm={12} md={4}>
                    <Grid container spacing={2}>
                        <Grid item sm={12} md={4}>
                            <Button variant="contained" disabled={sending} color='warning' endIcon={<BsClockHistory />} onClick={() => navigate(`/reviewer/ver-historial/${aprobAnun.anuncio.idAnuncio}`)}>
                                Historial
                            </Button>
                        </Grid>
                        <Grid item sm={12} md={4}>
                            <Button variant="contained" disabled={sending} color='error' endIcon={<TbSendOff />} onClick={handleClickOpen}>
                                Rechazar
                            </Button>
                        </Grid>
                        {aprobAnun.anuncio.bdEstado === 'P' ?
                            <Grid item sm={12} md={4}>
                                <Button variant="contained" disabled={sending} color='primary' endIcon={<TbSend />} onClick={() => Aprobar(aprobAnun.anuncio.idAnuncio)}>
                                    Aprobar
                                </Button>
                            </Grid>
                            : <></>
                        }

                    </Grid>
                </Grid>
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm" // Cambia a 'xs', 'sm', 'lg', etc.
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    Retroalimentación
                </DialogTitle>
                <DialogContent>
                    <SeguimientoForm idanuncio={aprobAnun.anuncio.idAnuncio} onResponse={handleResponse} />
                </DialogContent>
            </Dialog>
        </Container>
    );
}